module.exports = __webpack_public_path__ + "img/japanese-w.f6113b44.svg";